import HttpClient from './HttpClient';
import { OPINION_SERVICE_HOST, OPINIONS_API_PREFIX } from './RestConstants';

export interface FollowStatus {
  isFollowing: boolean;
  isFollowedBy: boolean;
  followersCount: number;
  followingCount: number;
}

export interface FollowResponse {
  success: boolean;
  message: string;
  data: {
    following: string[];
    followers: string[];
    followersCount: number;
    followingCount: number;
  };
}

export interface UserInfo {
  _id: string;
  username: string;
  email: string;
  profilePicture?: string;
  createdAt: string;
}

export interface FollowersResponse {
  success: boolean;
  data: {
    followers: UserInfo[];
    pagination: {
      page: number;
      limit: number;
      totalCount: number;
      totalPages: number;
    };
  };
}

export interface FollowingResponse {
  success: boolean;
  data: {
    following: UserInfo[];
    pagination: {
      page: number;
      limit: number;
      totalCount: number;
      totalPages: number;
    };
  };
}

export async function followUser(userId: string): Promise<FollowResponse> {
  const response = await HttpClient.POST({
    BASE_URL: OPINION_SERVICE_HOST,
    END_POINT: `${OPINIONS_API_PREFIX}/users/${userId}/follow`,
    data: {},
  });
  return response.data;
}

export async function unfollowUser(userId: string): Promise<FollowResponse> {
  const response = await HttpClient.POST({
    BASE_URL: OPINION_SERVICE_HOST,
    END_POINT: `${OPINIONS_API_PREFIX}/users/${userId}/unfollow`,
    data: {},
  });
  return response.data;
}

export async function getFollowStatus(userId: string): Promise<FollowStatus> {
  const response = await HttpClient.GET({
    BASE_URL: OPINION_SERVICE_HOST,
    END_POINT: `${OPINIONS_API_PREFIX}/users/${userId}/follow-status`,
  });
  return response.data.data;
}

export async function getUserFollowers(userId: string, page: number = 1, limit: number = 20): Promise<FollowersResponse> {
  const response = await HttpClient.GET({
    BASE_URL: OPINION_SERVICE_HOST,
    END_POINT: `${OPINIONS_API_PREFIX}/users/${userId}/followers?page=${page}&limit=${limit}`,
  });
  return response.data;
}

export async function getUserFollowing(userId: string, page: number = 1, limit: number = 20): Promise<FollowingResponse> {
  const response = await HttpClient.GET({
    BASE_URL: OPINION_SERVICE_HOST,
    END_POINT: `${OPINIONS_API_PREFIX}/users/${userId}/following?page=${page}&limit=${limit}`,
  });
  return response.data;
}
